
import SharePage from '@/components/share/SharePage';

export default {
    components: { SharePage },
}
